import axios from "axios";
import api from "@/router/api";
import { jwtDecode } from "jwt-decode";
import { useAuthStore } from "@/stores/auth";
import { iniciarTimerRenovacaoToken } from "@/utils/timerTokenRefresh";

const STI_CONFIG = {
  url: "https://autenticacao.devel.sti.ufc.br/auth/realms/UFC/protocol/openid-connect/token",
  clientId: "gex-frontend-russas",
  grantType: "password",
  scope:
    "openid pessoa:informacoes:cpf id_institucional pessoa:informacoes:email pessoa:informacoes:fullname",
};

let timerId = null;

async function loginSTI(usuario, senha) {
  const params = new URLSearchParams();
  params.append("grant_type", STI_CONFIG.grantType);
  params.append("client_id", STI_CONFIG.clientId);
  params.append("username", usuario);
  params.append("password", senha);
  params.append("scope", STI_CONFIG.scope);

  const response = await axios.post(STI_CONFIG.url, params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  if (!response.data.access_token) {
    throw new Error("Token de acesso não retornado pelo STI.");
  }

  return {
    accessToken: response.data.access_token,
    refreshToken: response.data.refresh_token,
  };
}

export async function autenticaoSigaaEgex(tokenSigaa) {
  try {
    const response = await api.post("/autenticacao/login-sti", null, {
      headers: { Authorization: `Bearer ${tokenSigaa}` },
    });
    return response;
  } catch (error) {
    if (error.data && error.data.error === "USER_NOT_SYNCED") {
      const config = {
        headers: {
          "X-SIGAA-Token": tokenSigaa,
        },
      };
      return await api.post("/autenticacao/first-login-sti", null, config);
    }
    throw error;
  }
}

export async function autenticarUsuarioSigaa(usuario, senha) {
  const auth = useAuthStore();
  let etapaAtual = "STI";
  try {
    const { accessToken, refreshToken } = await loginSTI(usuario, senha);

    const userInfo = jwtDecode(accessToken);
    const cpf = userInfo.cpf;

    etapaAtual = "GEX";

    const gexResponse = await autenticaoSigaaEgex(accessToken);

    if (gexResponse.data && gexResponse.data.token) {
      auth.atualizarSessao(
        gexResponse.data.token,
        gexResponse.data.refreshToken
      );
      window.localStorage.setItem("autenticadoSigaa", "autenticado");
    }

    iniciarTimerRenovacaoToken();

    return {
      perfilUser: {
        success: true,
        message: "Login realizado com sucesso.",
        data: gexResponse.data,
      },
      cpf: cpf,
      tokens: { accessToken, refreshToken },
    };
  } catch (error) {
    console.error(`Falha na autenticação (${etapaAtual}):`, error);

    let errorMessage = "Erro desconhecido.";

    if (etapaAtual === "STI") {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 400) {
          errorMessage = "Usuário ou senha do SIGAA inválidos.";
        } else {
          errorMessage = "Erro no servidor do STI (Keycloak).";
        }
      } else {
        errorMessage = "Não foi possível conectar ao servidor de autenticação.";
      }
    } else if (etapaAtual === "GEX") {
      const msgBackend = error?.data?.message || error?.response?.data?.message;
      errorMessage = msgBackend || "Erro de conexão ou autenticação no sistema GEX.";
    }

    return {
      perfilUser: {
        success: false,
        message: errorMessage,
      },
      cpf: null,
    };
  }
}

export function pararTimer() {
  if (timerId) {
    clearInterval(timerId);
    timerId = null;
  }
}
